<oph-select-menu
  [options]="hours"
  [buttonText]="hoursControl.value || '12'"
  [buttonStyle]="selectButtonStyle"
  (optionClick)="onTimeChange('hour', $event)"
>
</oph-select-menu>

<oph-select-menu
  [options]="minutes"
  [buttonText]="minutesControl.value || '00'"
  [buttonStyle]="selectButtonStyle"
  (optionClick)="onTimeChange('minute', $event)"
>
</oph-select-menu>

<oph-select-menu
  [options]="ampm"
  [buttonText]="ampmControl.value || 'AM'"
  [buttonStyle]="selectButtonStyle"
  (optionClick)="onTimeChange('ampm', $event)"
>
</oph-select-menu>
